import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { ShellFacade } from './shell.facade';

/**
 * The frame around every signed-in page, fed from the store through the shell facade.
 *
 * Default change detection on purpose, unlike the rest of the frame: this view declares the router
 * outlet, so every page is checked through it. Most pages still rely on default change detection;
 * behind an OnPush host they would stop refreshing when data arrives asynchronously.
 */
@Component({
    selector: 'app-layout',
    templateUrl: './app.layout.component.html',
    changeDetection: ChangeDetectionStrategy.Default,
    providers: [ShellFacade, DialogService],
    standalone: false,
})
export class AppLayoutComponent {
    constructor(readonly facade: ShellFacade) {}
}
